export const BETBY_DEFAULT_LANG = 'es';

export const BETBY_TOKEN_TTL_SECONDS = 3600;

/** Above fixed bottom nav (z-100) and page chrome; modals must sit higher. */
export const BETBY_BETSLIP_Z_INDEX = 110;

/** Fallback matching site header clearance (`top-20` / `pt-20`). */
export const BETBY_HEADER_OFFSET_PX = 80;

/** Fallback for authenticated/guest fixed bottom nav on mobile (< ls 900px). */
export const BETBY_MOBILE_FOOTER_OFFSET_PX = 72;

export const BETBY_DESKTOP_BREAKPOINT_PX = 900;

export const BETBY_HEADER_SELECTOR = '.navbar-content';

export const BETBY_BOTTOM_NAV_SELECTOR = '[data-betby-bottom-nav]';
